module.exports = __webpack_public_path__ + "static/media/Artboard6.e65c8416.jpg";